<!--Header-->
<app-navbar>
    <h2>Despre Agribusiness Specialisti</h2>
</app-navbar>
<!--Page info-->
<div class="portal-area pb-70">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col">
                <!--Title -->
                <h1>Despre Agribusinessjob Specialisti</h1>
                <p>Agribusinessjob SPECIALIST este divizia ce gestionează platforma de joburi specializată în sectorul agri-zoo-vet-food, divizie care ajută companiile să își desfășoare independent angajările, pentru a identifica, în timp optim, candidații potriviți. Cu ajutorul platformei de joburi, se pot recruta direct specialiști, din sectorul dvs. de activitate, prin postarea de joburi direct de către reprezentanții companiei dvs.</p>
            </div>
            <div class="col">
                <!-- Picture -->
                <img src="assets/img/about-us/agri-specialist.jpeg" alt="Portal">
            </div>
        </div>
    </div>
</div>
<!--Banner Jobs-->
<div class="counter-area pt-70 pb-70">
    <div class="container">
        <div class="row justify-content-center">
            <div class="text-center col-12 mt-20 mb-20">
                <!--Banner title-->
                <h2>AgribusinessJob</h2>
                <p>Munca noastră se vede și în cifre:</p>
            </div>
        </div>
        <!--Banner icons & counters-->
        <div class="row justify-content-center">
            <!--single icon & counter-->
            <div class="col-md-3">
                <div class="counter-item">
                    <!--single icon-->
                    <i class="flaticon-employee"></i>
                    <!--counter-->
                    <h3><span class="counter">22</span></h3>
                    <!--info counter-->
                    <p>Candidați</p>
                    <p>&nbsp;&nbsp;Disponibili</p>
                </div>
            </div>

            <!--single icon & counter-->
            <div class="col-md-3">
                <div class="counter-item">
                    <!--single icon-->
                    <i class="flaticon-curriculum"></i>
                    <!--counter-->
                    <h3><span class="counter">03</span></h3>
                    <!--info counter-->
                    <p>Locuri de muncă </p>
                    <p>disponibile</p>
                </div>
            </div>

            <!--single icon & counter-->
            <div class="col-md-3">
                <div class="counter-item">
                    <!--single icon -->
                    <i class="flaticon-enterprise"></i>
                    <!--counter-->
                    <h3><span class="counter">22</span></h3>
                    <!--info counter-->
                    <p>Companii</p>
                    <p>Angajatoare</p>
                </div>
            </div>

            <!--single icon & counter-->
            <div class="col-md-3">
                <div class="counter-item">
                    <!--single icon -->
                    <i class="flaticon-businessman-paper-of-the-application-for-a-job"></i>
                    <!--counter-->
                    <h3><span class="counter">23</span></h3>
                    <!--info counter-->
                    <p>ani de ABJ</p>
                </div>
            </div>
        </div>
    </div>
</div>
<!--pictures & info-->
<div class="info-area white-background">
    <div class="container-fluid overflow-hidden">
        <div class="row info-row pt-100 info-row-1">
            <div class="container">
                <!--block info-->
                <div class="info-block col-md-7">
                    <h3>ABJ Staff</h3>
                    <div class="empty-row-30"></div>
                    <p>The argument in favor of use filler goes something like this use real content in an design
                        process anytime you reach review point you’ll end up reviewing and negotiating a content it the
                        design inevitable argumentation Surprisingly, there is a very vocal faction of the design
                        community banished</p>
                    <div class="empty-row-30"></div>
                    <a class="simple-text-button" routerLink="/agribusiness-staff">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 info-row-2">
            <div class="container">
                <!--block info-->
                <div class="info-block col-md-7 offset-md-5">
                    <h3>ABJ Specialiști</h3>
                    <div class="empty-row-30"></div>
                    <p>The argument in favor of use filler goes something like this use real content in an design
                        process anytime you reach review point you’ll end up reviewing and negotiating a content it the
                        design inevitable argumentation Surprisingly, there is a very vocal faction of the design
                        community banished</p>
                    <div class="empty-row-30"></div>
                    <a routerLink="/agribusiness-specialisti" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 pb-100 info-row-3">
            <div class="container">
                <!--block info-->
                <div class="info-block col-md-7">
                    <h3>ABJ Junior</h3>
                    <div class="empty-row-30"></div>
                    <p>The argument in favor of use filler goes something like this use real content in an design
                        process anytime you reach review point you’ll end up reviewing and negotiating a content it the
                        design inevitable argumentation Surprisingly, there is a very vocal faction of the design
                        community banished</p>
                    <div class="empty-row-30"></div>
                    <a routerLink="/agribusiness-juniori"  class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Banner Domains-->
<div class="counter-area pt-70 pb-70">
    <div class="container">
        <!--domains title & info-->
        <div class="row justify-content-center">
            <div class="text-center col-12 mt-20 mb-10">
                <h2> Domeniile AgribusinessJob</h2>
                <p>Facilităm procese sănătoase de recrutare și dezvoltare în
                    carieră pentru Companii și Specialiști </p>
                <p>încă din 1998</p>
            </div>
        </div>
        <!--domains icons & counters-->
        <div class="row justify-content-center pb-20">
            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-employee"></i>
                    <!--info & counter-->
                    <h2>Agricultură</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>

                </div>
            </div>
            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-curriculum"></i>
                    <!--info & counter-->
                    <h2>Horticultură</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>

            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-enterprise"></i>
                    <!--info & counter-->
                    <h2>Apicultură</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>

            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-businessman-paper-of-the-application-for-a-job"></i>
                    <!--info & counter-->
                    <h2>Zootehnie</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>

            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-businessman-paper-of-the-application-for-a-job"></i>
                    <!--info & counter-->
                    <h2>Ind. Alimentară</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>
        </div>
        <!--button more jobs-->
        <div class="text-center col-12 pb-10">
            <a class="green-button">VEZI TOATE JOBURILE</a>
        </div>

    </div>
</div>
<!--Bottom pictures-->
<div class="picture-area">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <!-- left picture-->
                <div class="row">
                    <div class="col">
                        <!-- left picture info-->
                        <div class="pictureLeft">
                            <h2>Vrei să te angajezi?</h2>
                            <h1>Căutarea a luat sfârșit.Descoperă serviciile</h1>
                            <p>Agribusiness Job pentru companii</p>
                            <a href="#" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>

                        </div>
                    </div>
                    <!-- right picture-->
                    <div class="col">
                        <!-- right picture info-->
                        <div class="pictureRight">
                            <h2>Cauți loc de muncă?</h2>
                            <h1>Află cum poți face următorul pas în carieră cu</h1>
                            <p>Agribusiness Job</p>
                            <a href="#" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<!--Footer-->
<app-footer></app-footer>
